import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import NavBar from './components/NavBar';
import SiteFooter from './components/SiteFooter';
import SongList from './components/SongList';
import { initGA, logPageView } from './analytics';

const NewSong = React.lazy(() => import('./components/NewSong'));
const SongView = React.lazy(() => import('./components/SongView'));


const TRACKING_ID = "G-4P77TNS35K";

const App: React.FC = () => {
  useEffect(() => {
    initGA(TRACKING_ID);
  }, []);

  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return (
    <>
      <NavBar />
      <main id="main">
      <React.Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<SongList />} />
          <Route path="/new" element={<NewSong />} />
          <Route path="/song/:id" element={<SongView />} />
        </Routes>
      </React.Suspense>
      </main>
      <SiteFooter />
    </>
  );
};

export default App;